import { all, takeEvery, call, put } from "redux-saga/effects";
import { recordList, recordTotal, clearData } from "services/apis/gauge";
import actions from "./actions";
import * as _ from "lodash";

function* listLoading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      listLoading: isLoading,
      error,
    },
  });
}

function* totalLoading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      totalLoading: isLoading,
      error,
    },
  });
}

export function* RECORD_LIST({ payload }) {
  yield listLoading(true);

  const response = yield call(recordList, payload);
  if (response) {
    const meta = _.omit(response, "items");
    yield put({
      type: actions.SET_STATE,
      payload: {
        listLoading: false,
        list: response.items,
        meta,
      },
    });
  }
  if (!response) {
    yield listLoading(false, true);
  }
}

export function* RECORD_TOTAL({ payload }) {
  yield totalLoading(true);

  const response = yield call(recordTotal, payload);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        total: response.items ? response.items : [],
        alertTotal: response.alertItems ? response.alertItems : [],
        totalLoading: false,
      },
    });
  }

  if (!response) {
    yield totalLoading(false, true);
  }
}

export function* CLEAR_DATA({ payload }) {
  const { id, body, filter } = payload;

  yield listLoading(true);

  const response = yield call(clearData, id, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        listLoading: false,
      },
    });
    yield put({ type: actions.RECORD_LIST, payload: filter });
  }

  if (!response) {
    yield listLoading(false, true);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.RECORD_LIST, RECORD_LIST),
    takeEvery(actions.RECORD_TOTAL, RECORD_TOTAL),
    takeEvery(actions.CLEAR_DATA, CLEAR_DATA),
  ]);
}
